import { motion } from "framer-motion";
import { Chapter, EASE, MaskedLine, Reveal } from "../components/motion";
import { config } from "../config/siteConfig";

const BtsMethod = () => (
  <section
    id="method"
    data-testid="bts-method-section"
    className="relative bg-[#08162B] text-white py-24 lg:py-36 overflow-hidden"
  >
    <div className="absolute inset-0 hero-grid pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <Chapter index="03" label="The BTS Method™" dark />

      <h2 className="mt-10 font-sans font-extrabold uppercase tracking-[-0.02em] leading-[0.92] text-[clamp(3rem,10vw,8.5rem)]">
        <MaskedLine delay={0.1}>BUILD IT.</MaskedLine>
        <MaskedLine delay={0.22} className="text-white/35">TEST IT.</MaskedLine>
        <MaskedLine delay={0.34} className="text-[#D4AF37]">SCALE IT.</MaskedLine>
      </h2>

      <Reveal delay={0.3} className="mt-10 max-w-2xl">
        <p className="text-lg sm:text-xl leading-relaxed text-white/60">
          Most aspiring ecommerce entrepreneurs try to <span className="text-white">scale</span>{" "}
          something they haven't properly <span className="text-white">built</span> or{" "}
          <span className="text-white">tested</span>. The Ecom Bible puts the process back in the
          correct order.
        </p>
      </Reveal>

      <div className="mt-20 grid lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {config.bts.map((phase, i) => (
          <motion.article
            key={phase.num}
            data-testid={`bts-phase-${phase.num}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-8% 0px" }}
            transition={{ duration: 0.9, delay: i * 0.15, ease: EASE }}
            className="bg-[#08162B] p-8 sm:p-10 lg:p-12"
          >
            <p className="font-mono text-sm text-[#D4AF37] tracking-[0.3em]">{phase.num}</p>
            <h3 className="mt-5 font-sans font-extrabold uppercase tracking-tight text-3xl sm:text-4xl">
              {phase.title}
            </h3>
            <p className="mt-3 font-condensed font-light text-lg sm:text-xl text-white/60">{phase.tagline}</p>
            <ul className="mt-8">
              {phase.topics.map((topic, j) => (
                <motion.li
                  key={topic}
                  initial={{ opacity: 0, x: -14 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.2 + j * 0.05, ease: EASE }}
                  className="border-t border-white/10 py-3 font-mono text-[11px] sm:text-xs uppercase tracking-[0.18em] text-white/55"
                >
                  {topic}
                </motion.li>
              ))}
            </ul>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default BtsMethod;
